import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Lock } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  AuthDivider,
  AuthFormLayout,
  AuthOutlineButton,
  FloatingTextField,
  SefanoButton,
} from "@/components";
import { TermsDialog } from "@/components/Organisms/TermsDialog";
import type { OtpPhoneTemplateProps } from "./OtpPhone.template.types";
import * as styles from "./OtpPhone.template.styles";

export type { OtpPhoneTemplateProps } from "./OtpPhone.template.types";

export function OtpPhoneTemplate({
  register,
  handleSubmit,
  onSubmit,
  errors,
  isPending,
}: OtpPhoneTemplateProps) {
  const { t } = useTranslation("auth");
  const theme = useTheme();
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <AuthFormLayout
      title={t("otp_phone_title")}
      subtitle={
        <>
          {t("otp_phone_subtitle_line1")}
          <br />
          {t("otp_phone_subtitle_line2")}
        </>
      }
      headerSpacing="spacious"
    >
      <Stack component="form" sx={styles.form} onSubmit={handleSubmit(onSubmit)} noValidate>
        <FloatingTextField
          label={t("phone")}
          placeholder={t("please_insert_phone")}
          type="tel"
          autoComplete="tel"
          inputMode="numeric"
          dir="ltr"
          error={Boolean(errors.phone)}
          helperText={errors.phone?.message}
          {...register("phone")}
        />

        <SefanoButton type="submit" fullWidth disabled={isPending}>
          {isPending ? t("loading") : t("send_otp_code")}
        </SefanoButton>
      </Stack>

      <AuthDivider />

      <AuthOutlineButton
        to="/login"
        icon={<Lock size={20} variant="Linear" color={theme.palette.primary.main} />}
      >
        {t("login_with_password")}
      </AuthOutlineButton>

      <Typography sx={styles.termsNote}>
        {t("otp_terms_prefix")}{" "}
        <Typography
          component="button"
          type="button"
          sx={styles.termsLink}
          onClick={() => setTermsOpen(true)}
        >
          {t("terms_and_conditions")}
        </Typography>{" "}
        {t("otp_terms_suffix")}
      </Typography>

      <TermsDialog open={termsOpen} onClose={() => setTermsOpen(false)} />
    </AuthFormLayout>
  );
}
